/**
 * 平台类型
 */
export enum EPlatformType {
    IOS = 'ios',
    ANDROID = 'android',
    H5 = 'h5',
}

export const CUSTOM_HEIGHT = {
    DefaultAreaInsetTop: 44,
    DefaultNav: 44,
};
